module.exports = __webpack_public_path__ + "static/media/origami17.a1e1b99b.JPG";